module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-8.322dee8e.jpg";